import Vue from 'vue';

export function round(value: any, precision: number): string {
  return Number.parseFloat(value).toFixed(precision);
}
